import DividerWithOR from "./DividerWithOR";

export default DividerWithOR;
